
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";
import { firsebase } from "../environment/index";
const firebaseConfig = {
  apiKey: firsebase.apiKey,
  authDomain: firsebase.authDomain,
  projectId: firsebase.projectId,
  storageBucket: firsebase.storageBucket,
  messagingSenderId: firsebase.messagingSenderId,
  appId: firsebase.appId,
  measurementId: firsebase.measurementId
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const messaging = getMessaging(app);

export { messaging };